import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";

/**
 * @file Created on Fri Jul 27 2018
 * @author VBr
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { StoreName } from '../../../shared/stores/StoreName';
import { T } from '../../i18n/T';
import translate from '../../i18n/translate';
import Icon, { IconType } from '../../media/Icon';
import PrivilegesControl from '../../security/PrivilegesControl';
import StyledMenu from './styled/Menu';
import { CONSTANTS } from '../../../constants';

var Menu =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Menu, _React$Component);

  function Menu(props) {
    var _this;

    _classCallCheck(this, Menu);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Menu).call(this, props)); // this.toggleMenu = this.toggleMenu.bind(this);

    _this.getFirstTier = _this.getFirstTier.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.getSecondTier = _this.getSecondTier.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.getThirdTier = _this.getThirdTier.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }
  /** Renders main menu layout with hamburger */


  _createClass(Menu, [{
    key: "render",
    value: function render() {
      var version = this.props.store.config[CONSTANTS.APP.NAME === 'promo' ? 'promoVersion' : 'pricingVersion'];
      return React.createElement(StyledMenu, {
        className: "layout-sidebar".concat(this.props.store.menuExpanded ? ' layout-sidebar--open' : '')
      }, React.createElement("nav", {
        className: "nav-main"
      }, React.createElement("div", {
        className: "nav-main-item"
      }, React.createElement("span", {
        className: "nav-main-item-icon",
        id: "back-button"
      })), React.createElement("div", {
        className: "nav-main-item"
      }, React.createElement("span", {
        className: "nav-main-item-icon nav-main-item-icon-hamburger"
      }, React.createElement("a", {
        onClick: this.props.store.toggleMenu
      }, React.createElement(Icon, {
        iconType: IconType.menu
      })))), this.getFirstTier(this.props.navigation), React.createElement("div", {
        className: "nav-main-item nav-main-item--single nav-main-item-btm"
      }, React.createElement("span", {
        className: "nav-main-item-icon"
      }, React.createElement("a", {
        target: "_blank",
        href: this.props.documentationPath
      }, React.createElement(Icon, {
        iconType: "HELP",
        iconColor: "inverse"
      }))), this.props.store.menuExpanded && this.props.store.config != null && version != null && React.createElement("div", {
        className: "version"
      }, translate('Version'), ": ", version))));
    }
    /** Renders first level menu */

  }, {
    key: "getFirstTier",
    value: function getFirstTier(navigation) {
      var _this2 = this;

      return navigation.map(function (route, index) {
        var mainItemClasses = ['nav-main-item'];

        if (!_this2.hasSubLinks(route)) {
          mainItemClasses.push('nav-main-item--single');
        }

        if (_this2.props.store.menuOpened.includes(route.name)) {
          mainItemClasses.push('nav-main-item-sub--open');
        }

        if (route.exact && _this2.props.path === translate(route.path)) {
          mainItemClasses.push('nav-main-item--selected');
        } else if (!route.exact && _this2.props.path.indexOf(translate(route.path)) !== -1) {
          mainItemClasses.push('nav-main-item--selected');
        }

        return React.createElement(PrivilegesControl, {
          key: index,
          privileges: route.privileges,
          hideError: true
        }, !route.hide && React.createElement("div", {
          className: mainItemClasses.join(' '),
          key: route.name
        }, React.createElement("span", {
          className: "nav-main-item-icon"
        }, route.empty ? React.createElement("a", null, React.createElement(Icon, {
          iconType: route.routeIconType,
          iconColor: "inverse"
        })) : React.createElement(Link, {
          to: translate(route.path)
        }, React.createElement(Icon, {
          iconType: route.routeIconType,
          iconColor: "inverse"
        }))), React.createElement("div", {
          className: "nav-main-item-content"
        }, React.createElement("div", {
          className: "nav-main-item-title"
        }, route.empty ? React.createElement("a", {
          onClick: function onClick() {
            return _this2.props.store.toggleMenuItem(route.name);
          }
        }, React.createElement(T, {
          id: route.name
        })) : React.createElement(Link, {
          to: translate(route.path)
        }, React.createElement(T, {
          id: route.name
        })), _this2.hasSubLinks(route) && React.createElement("a", {
          className: "nav-main-item-sub-trigger",
          onClick: function onClick() {
            return _this2.props.store.toggleMenuItem(route.name);
          }
        })), _this2.hasSubLinks(route) && _this2.getSecondTier(route.routes))));
      });
    }
    /** Renders second level menu */

  }, {
    key: "getSecondTier",
    value: function getSecondTier(navigation) {
      var _this3 = this;

      return React.createElement("div", {
        className: "nav-main-item-sub"
      }, navigation.map(function (route, index) {
        var active = false;
        var opened = false;

        if (_this3.props.store.menuOpened.includes(route.name)) {
          opened = true;
        }

        if (route.exact && _this3.props.path === translate(route.path)) {
          active = true;
        } else if (!route.exact && _this3.props.path.indexOf(translate(route.path)) !== -1) {
          active = true;
        }

        if (!route.hide && route.routes) {
          return React.createElement(PrivilegesControl, {
            key: index,
            privileges: route.privileges ? route.privileges : [],
            hideError: true
          }, React.createElement("div", {
            className: "nav-main-sub-sub".concat(opened ? ' nav-main-item-sub-sub--open' : ''),
            key: route.name
          }, React.createElement("div", {
            className: "nav-main-sub-sub-title"
          }, route.empty ? React.createElement("a", {
            className: active ? 'nav-main-sub--selected' : undefined,
            onClick: function onClick() {
              return _this3.hasSubLinks(route) ? _this3.props.store.toggleMenuItem(route.name) : undefined;
            }
          }, React.createElement(T, {
            id: route.name
          })) : React.createElement(Link, {
            to: translate(route.path),
            className: active ? 'nav-main-sub--selected' : undefined
          }, React.createElement(T, {
            id: route.name
          })), _this3.hasSubLinks(route) && React.createElement("a", {
            className: "nav-main-item-sub-sub-trigger",
            onClick: function onClick() {
              return _this3.props.store.toggleMenuItem(route.name);
            }
          })), _this3.hasSubLinks(route) && _this3.getThirdTier(route.routes)));
        } else if (!route.hide) {
          return React.createElement(PrivilegesControl, {
            key: index,
            privileges: route.privileges ? route.privileges : [],
            hideError: true
          }, route.empty ? React.createElement("a", {
            className: active ? ' nav-main-sub--selected' : undefined,
            key: route.name
          }, React.createElement(T, {
            id: route.name
          })) : route.isExternal ? React.createElement("a", {
            href: route.path
          }, React.createElement(T, {
            id: route.name
          })) : React.createElement(Link, {
            to: translate(route.path),
            className: active ? ' nav-main-sub--selected' : undefined,
            key: route.name
          }, React.createElement(T, {
            id: route.name
          })));
        }

        return null;
      }));
    }
    /** Renders third level menu */

  }, {
    key: "getThirdTier",
    value: function getThirdTier(navigation) {
      var _this4 = this;

      return React.createElement("div", {
        className: "nav-main-sub-sub-content"
      }, navigation.map(function (route) {
        if (!route.hide) {
          return React.createElement(Link, {
            key: route.name,
            to: translate(route.path),
            className: _this4.props.store.menuOpened.includes(route.name) ? 'nav-main-sub--selected' : undefined
          }, React.createElement(T, {
            id: route.name
          }));
        }

        return null;
      }));
    }
    /** Return true if route has any !!visible!! subroutes */

  }, {
    key: "hasSubLinks",
    value: function hasSubLinks(route) {
      if (route.routes) {
        return route.routes.some(function (item) {
          return !item.hide;
        });
      }

      return false;
    }
  }]);

  return Menu;
}(React.Component);

Menu = __decorate([inject(function (allStores) {
  return {
    store: allStores[StoreName.GeneralConfigurations]
  };
}), observer, __metadata("design:paramtypes", [Object])], Menu);
export default Menu;